import React from 'react';
import { BrandMark } from './BrandMark';
import { CONTACT } from './content';
import { scrollToSection } from './LandingHeader';

export function LandingFooter({ copy, onLogin }) {
  const footer = copy.footer;
  return (
    <footer className="bg-[#0A0A0A] pb-10 pt-16" data-testid="landing-footer">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="grid gap-12 md:grid-cols-[1.4fr_1fr_1fr]">
          <div>
            <BrandMark tone="light" size="lg" />
            <p className="mt-6 max-w-xs font-display text-lg italic text-[#CFC8BE]">{footer.tagline}</p>
            <p className="mt-3 max-w-xs font-landing text-xs leading-relaxed text-[#8F887B]">{footer.privacyNote}</p>
          </div>

          <nav aria-label="Footer">
            <ul className="space-y-3 font-landing text-[0.8rem] uppercase tracking-[0.16em]">
              {[['products', copy.nav.products], ['sites', copy.nav.sites], ['why', copy.nav.why], ['contact', copy.nav.contact]].map(([id, label]) => (
                <li key={id}>
                  <button type="button" onClick={() => scrollToSection(id)} className="text-[#CFC8BE] transition-colors hover:text-[#D4AF37] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#D4AF37]">{label}</button>
                </li>
              ))}
              <li>
                <button type="button" onClick={onLogin} className="text-[#CFC8BE] transition-colors hover:text-[#D4AF37] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#D4AF37]">{copy.nav.login}</button>
              </li>
            </ul>
          </nav>

          <div className="font-landing text-sm leading-relaxed text-[#CFC8BE]">
            <a href={`mailto:${CONTACT.email}`} className="block hover:text-[#D4AF37]">{CONTACT.email}</a>
            <a href={CONTACT.phoneHref} className="mt-2 block hover:text-[#D4AF37]">{CONTACT.phone}</a>
            <p className="mt-2 text-[#8F887B]">{CONTACT.location}</p>
          </div>
        </div>

        <div className="mt-14 flex flex-col gap-2 border-t border-[#D4AF37]/25 pt-6 font-landing text-xs text-[#8F887B] sm:flex-row sm:items-center sm:justify-between">
          <p>&copy; {new Date().getFullYear()} Valhalla Corporations S.E.P. {footer.rights}</p>
          <p>{footer.ruc}</p>
        </div>
      </div>
    </footer>
  );
}
